export default {
  line2Title: "请选择你要进入的社区：".toUpperCase(),
  line3Title: "我想查找和了解：".toUpperCase(),

  english: "英语圈".toUpperCase(),
  russian: "俄语圈".toUpperCase(),
  chinese: "中文圈".toUpperCase(),
  spanish: "西语圈".toUpperCase(),
  french: "法语圈".toUpperCase(),

  chat: "聊天群".toUpperCase(),
  markets: "交易市场".toUpperCase(),
  forums: "论坛".toUpperCase(),
  "top sellers": "顶级卖家".toUpperCase(),
  essentials: "必备精选".toUpperCase(),
  others: "其他类别".toUpperCase(),
}
